import cLang from '../Images/letter-c.png';
import Cpp from '../Images/c++.png';
import Css from '../Images/css.png';
import PythonIcon from '../Images/python.png';
import HTMLIcon from '../Images/html-5.png';
import jsIcon from '../Images/js.png'
import ReactIcon from '../Images/ReactIcon.png'

let SkillsData = [
    {
        id: 1,
        language: 'C',
        icon: cLang,
    },
    {
        id: 2,
        language: 'C++',
        icon: Cpp,
    },
    {
        id: 3,
        language: 'Python', PythonIcon,
        icon: PythonIcon,
    },
    {
        id: 4,
        language: 'HTML',
        icon: HTMLIcon,
    },
    {
        id: 5,
        language: 'CSS',
        icon: Css,
    },
    {
        id: 6,
        language: 'JavaScript',
        icon: jsIcon,
    },
    {
        id: 7,
        language: 'ReactJs',
        icon: ReactIcon,
    },
];

export default SkillsData;